import { render, staticRenderFns } from "./SuperbAnalytics.vue?vue&type=template&id=46886a66&scoped=true&"
import script from "./SuperbAnalytics.vue?vue&type=script&lang=js&"
export * from "./SuperbAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./SuperbAnalytics.vue?vue&type=style&index=0&id=46886a66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46886a66",
  null
  
)

export default component.exports